import React from "react";

function DevelopLove() {
  return (
    <React.Fragment>
      <div className="developLove">
        <div className="overlay"></div>
        <div className="container">
          <div className="row">
            <div
              className="col-md-7 col-lg-4"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div className="card">
                <h1>Develop Love For Luxury</h1>
                <p>
                  BOOK OR BUY LUXURY APARTMENTS, MULTIPURPOSE SHOPS,COMMERICAL &
                  RESIDENTIAL PLOTS IN BAHRIA TOWN.
                </p>
                <button href="" className="btn btn-outline-light">
                  Read More
                </button>
              </div>
            </div>
            <div className="col-md-4 col-lg-8"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default DevelopLove;
